"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonialsData = [{
  author: "Carlos Méndez",
  quote: "Gracias a la formación práctica de ECAP, hoy lidero mi propio equipo de instalaciones eléctricas en Salto con total seguridad.",
  position: "Egresado en Técnico Electricista",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduado-electricista.png"
}, {
  author: "Lucía Rodríguez",
  quote: "El curso de Barbería no solo me dio la técnica, sino la confianza para abrir mi propio salón y emprender en mi ciudad.",
  position: "Egresada en Barbería Profesional",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduada-barberia.png"
}, {
  author: "Mateo Silva",
  quote: "La formación en Kinesiología Deportiva me permitió entender la biomecánica aplicada y hoy trabajo con atletas de alto rendimiento.",
  position: "Egresado en Kinesiología Deportiva",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_kinesiology.png"
}, {
  author: "Elena Paz",
  quote: "Aprendí técnicas de Masoterapia que transformaron mi visión del bienestar. Mis clientes notan la profesionalidad en cada sesión.",
  position: "Egresada en Masoterapia",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_massage.png"
}, {
  author: "Jorge Brun",
  quote: "El curso de Aires Acondicionados es 100% práctico. Salí listo para instalar y reparar equipos, lo que me dio una salida laboral inmediata.",
  position: "Egresado en Técnico en Aires Acondicionados",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_ac_technician.png"
}, {
  author: "Ricardo Sosa",
  quote: "ECAP me brindó las herramientas necesarias para liderar proyectos en el sector forestal con una base técnica muy sólida.",
  position: "Egresado en Supervisor Forestal",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_forest_supervisor.png"
}, {
  author: "Fabián Dutra",
  quote: "La electrónica siempre fue mi pasión y en este curso encontré el camino profesional que buscaba para mi futuro.",
  position: "Egresado en Técnico en Electrónica",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_electronics.png"
}, {
  author: "Andrés Costa",
  quote: "Un curso visionario para el futuro energético de Uruguay. La formación en Energía Solar es clave para el mercado actual.",
  position: "Egresado en Técnico en Energía Solar",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_solar_energy.png"
}, {
  author: "Sofía Martínez",
  quote: "Mejoré mis habilidades contables y administrativas notablemente. La modalidad de estudio se adaptó perfecto a mis tiempos.",
  position: "Egresada en Auxiliar Administrativo Contable",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_accounting_assistant.png"
}, {
  author: "Valentina Ferreyra",
  quote: "Saber cómo actuar en emergencias es vital. El curso de Primeros Auxilios me dio la seguridad para responder ante cualquier situación.",
  position: "Egresada en Primeros Auxilios",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_first_aid.png"
}, {
  author: "Ignacio Techera",
  quote: "Las clases de Entrenamiento Funcional son dinámicas y los docentes están muy preparados. Me ayudó a profesionalizar mis rutinas.",
  position: "Egresado en Entrenamiento Funcional",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_functional_training.png"
}, {
  author: "Marcos Lima",
  quote: "Ahora tengo mi propio grupo de entrenamiento en el gimnasio gracias a lo aprendido como instructor. Una experiencia excelente.",
  position: "Egresado en Instructor en Sala de Musculación",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_gym_instructor.png"
}, {
  author: "Beatriz Núñez",
  quote: "La Reflexología Podal ofrece un enfoque holístico que mis clientes agradecen cada día. La técnica enseñada es impecable.",
  position: "Egresada en Reflexología Podal",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_reflexology.png"
}, {
  author: "Gabriela Santos",
  quote: "La técnica de Auriculoterapia es precisa y efectiva. Complementa perfectamente mis otros servicios de bienestar y salud.",
  position: "Egresada en Auriculoterapia",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_auriculotherapy.png"
}, {
  author: "Roberto Gómez",
  quote: "Fundamental para cualquier profesional que maneje personal. La claridad con la que explican la liquidación de sueldos es única.",
  position: "Egresado en Legislación Laboral y Liquidación de Sueldos",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_labor_law.png"
}, {
  author: "Camila Borges",
  quote: "Pasé de un nivel básico a avanzado en Excel en muy poco tiempo. Es una herramienta que uso todos los días en mi trabajo.",
  position: "Egresada en Excel Profesional",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_excel_expert.png"
}, {
  author: "Diego Pereira",
  quote: "ECAP me dio las herramientas técnicas y la confianza para lanzar mi propio canal de streaming y mejorar mi locución.",
  position: "Egresado en Conducción, Locución y Streaming",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_streaming_voiceover.png"
}, {
  author: "Hugo Morales",
  quote: "Aprendí procesos de producción modernos que aplico hoy mismo en mi emprendimiento rural con excelentes resultados.",
  position: "Egresado en Producción Avícola",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_poultry_production.png"
}, {
  author: "Natalia Ruiz",
  quote: "La precisión técnica que enseñan en el curso de pestañas es excelente. Mis clientas están felices con los resultados naturales.",
  position: "Egresada en Extensiones de Pestañas",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_eyelash_extensions.png"
}, {
  author: "Luis Alberto",
  quote: "Ahora realizo presupuestos de obras profesionales con total confianza. El curso me dio el orden que mi negocio necesitaba.",
  position: "Egresado en Presupuestación de Obras",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/graduated_construction_budgeting.png"
}];
export default function Testimonials() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section data-section-id="105066" id="experiencias-ecap" className="py-20 md:py-32 bg-background dark text-foreground overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tighter uppercase">
            Lo que dicen nuestros <span className="text-primary">Graduados</span>
          </h2>
          <div className="w-24 h-1.5 bg-secondary mx-auto mt-6 rounded-full shadow-[0_0_15px_rgba(251,191,36,0.5)]" />
        </div>

        <div className="max-w-5xl mx-auto">
          <Carousel setApi={setApi} opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonialsData.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-16 p-4 md:p-8">
                    <div className="shrink-0 relative">
                      <div className="absolute inset-0 bg-primary/20 rounded-full blur-3xl transform scale-150" />
                      <SafeHydrate><Avatar className="size-32 md:size-48 border-4 border-secondary shadow-2xl relative z-10">
                        <AvatarImage src={testimonial.image} alt={testimonial.author} className="object-cover" />
                        <AvatarFallback className="text-4xl font-bold bg-primary/20 text-primary">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                    </div>
                    
                    <div className="flex-1 text-center md:text-left space-y-6 md:space-y-8 pt-4 md:pt-8">
                      <Quote className="size-12 md:size-16 text-primary/10 mx-auto md:mx-0 transform -scale-x-100" />
                      <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl text-foreground leading-relaxed backdrop-blur-sm bg-background/5 p-2 rounded-xl">
                        "{testimonial.quote}"
                      </p>
                      <div className="space-y-1">
                        <h4 className="font-bold text-xl md:text-2xl text-foreground tracking-tight">
                          {testimonial.author}
                        </h4>
                        <p className="text-secondary font-medium text-lg uppercase tracking-wider">
                          {testimonial.position}
                        </p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            <div className="flex items-center justify-center gap-6 md:gap-8 mt-12 md:mt-20">
              <CarouselPrevious className="static translate-y-0 translate-x-0 left-auto right-auto top-auto bottom-auto size-12 border-2 border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground transition-all duration-300 shadow-lg" />
              
              <div className="flex items-center gap-3">
                {Array.from({
                length: count
              }).map((_, i) => <Button key={i} data-index={i} variant="ghost" className={`size-3 rounded-full p-0 min-h-0 min-w-0 transition-all duration-300 ${current === i + 1 ? "bg-secondary w-10 shadow-[0_0_10px_rgba(251,191,36,0.6)]" : "bg-secondary/20 hover:bg-secondary/50"}`} onClick={() => api?.scrollTo(i)} aria-label={`Ir a testimonio ${i + 1}`} />)}
              </div>

              <CarouselNext className="static translate-y-0 translate-x-0 left-auto right-auto top-auto bottom-auto size-12 border-2 border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground transition-all duration-300 shadow-lg" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}